import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import { fetchNavbarAndFooter } from "lib/fetchers/common";

import { SiftedForAngelsView } from "content-ui/sifted-for-angels";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import {
  SelfServePageData,
  fetchSelfServePageData,
} from "content-ui/sifted-for-angels/fetcher";
import { SEO_SIFTED_ON_PINK_IMAGE } from "lib/constants/shared";

export async function getServerSideProps({ res, preview = false }) {
  const [menuItems, pageData] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchSelfServePageData({ preview }),
  ]);

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  return {
    props: {
      pageData,
      previewMode: preview,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
  };
}

export type SelfServePageProps = {
  pageData: SelfServePageData;
  previewMode: boolean;
};

const SelfServePage = (props: SelfServePageProps) => {
  const { seo } = props.pageData;
  const title = seo?.title || "Sifted for Angels";
  const description = seo?.description || "";
  const seoImage = seo?.image?.url || SEO_SIFTED_ON_PINK_IMAGE;

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/sifted-for-angels"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
        <meta name="robots" content="noindex" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <SiftedForAngelsView data={props.pageData} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default SelfServePage;
